export const charadesPrompts = {
    movies: [
        'Titanic',
        'Jurassic Park',
        'The Matrix',
        'Toy Story',
        'Spider-Man',
        'Frozen',
        'The Lion King',
        'Star Wars',
        'Home Alone',
        'Finding Nemo',
    ],
    actions: [
        'Brushing your teeth',
        'Walking a dog',
        'Riding a bike',
        'Cooking pasta',
        'Flying a kite',
        'Dancing salsa',
        'Playing guitar',
        'Fishing',
        'Climbing a ladder',
        'Swimming freestyle',
    ],
    animals: [
        'Elephant',
        'Penguin',
        'Kangaroo',
        'Shark',
        'Gorilla',
        'Cat',
        'Dog',
        'Snake',
        'Horse',
        'Octopus',
    ],
    random: [
        'Umbrella',
        'Volcano',
        'Robot',
        'Pizza',
        'Library',
        'Baseball',
        'Rainbow',
        'Backpack',
        'Helicopter',
        'Candle',
    ],
};

export const getCharadesDeck = (enabledCategories) => {
    const categories = enabledCategories?.length ? enabledCategories : Object.keys(charadesPrompts);
    const deck = categories.flatMap((category) => charadesPrompts[category] || []);
    return [...deck].sort(() => Math.random() - 0.5);
};
